/* eslint-disable @typescript-eslint/no-explicit-any */

import { TOUCH_DELAY, LEAVE_TOUCH_DELAY } from '../../../../internal/constants';
export function useTooltipControllerTouch(dependencies) {
  var state = dependencies.state,
    handleEnter = dependencies.handleEnter,
    handleClose = dependencies.handleClose;
  var timers = state.timers;
  var children = dependencies.props.children;
  var handleTouchStart = function handleTouchStart(event) {
    state.ignoreNonTouchEvents = true;
    var childrenProps = children.props;
    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
    window.clearTimeout(timers.leave);
    window.clearTimeout(timers.touch);
    event.persist();
    timers.touch = window.setTimeout(function () {
      handleEnter(event);
    }, TOUCH_DELAY);
  };
  var handleTouchEnd = function handleTouchEnd(event) {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }
    window.clearTimeout(timers.touch);
    window.clearTimeout(timers.leave);
    event.persist();
    timers.leave = window.setTimeout(function () {
      handleClose();
    }, LEAVE_TOUCH_DELAY);
  };
  return {
    handleTouchStart: handleTouchStart,
    handleTouchEnd: handleTouchEnd
  };
}